<template>
  <a-popover v-model="visible" title="添加流程节点" trigger="click" placement="rightTop">
    <div slot="content" class="node-select">
      <div @click="addApprovalNode">
        <i class="el-icon-s-check" style="color: rgb(255, 148, 62)" />
        <span>审批人</span>
      </div>
      <div v-if="false" @click="addCcNode">
        <i class="el-icon-s-promotion" style="color: rgb(50, 150, 250)" />
        <span>抄送人</span>
      </div>
      <div @click="addConditionsNode">
        <i class="el-icon-share" style="color: rgb(21, 188, 131)" />
        <span>条件分支</span>
      </div>
      <div v-if="false" @click="addConcurrentsNode">
        <i class="el-icon-s-operation" style="color: #718dff" />
        <span>并行分支</span>
      </div>
      <div v-if="false" @click="addDelayNode">
        <i class="el-icon-time" style="color: #f25643" />
        <span>延迟等待</span>
      </div>
      <div v-if="false" @click="addTriggerNode">
        <i class="el-icon-set-up" style="color: #15bc83" />
        <span>触发器</span>
      </div>
    </div>
    <a-button type="primary" icon="plus" shape="circle" size="small" />
  </a-popover>
</template>

<script>
export default {
  name: 'InsertButton',
  components: {},
  data() {
    return {
      visible: false
    };
  },
  computed: {
    selectedNode() {
      return this.$store.state.selectedNode;
    }
  },
  methods: {
    addApprovalNode() {
      this.visible = false;
      this.$emit('insertNode', 'APPROVAL');
    },
    addCcNode() {
      this.visible = false;
      this.$emit('insertNode', 'CC');
    },
    addDelayNode() {
      this.visible = false;
      this.$emit('insertNode', 'DELAY');
    },
    addConditionsNode() {
      this.visible = false;
      this.$emit('insertNode', 'CONDITIONS');
    },
    addConcurrentsNode() {
      this.visible = false;
      this.$emit('insertNode', 'CONCURRENTS');
    },
    addTriggerNode() {
      this.visible = false;
      this.$emit('insertNode', 'TRIGGER');
    }
  }
};
</script>

<style lang="less" scoped>
.ant-popover-inner-content {
  padding: 8px;
}
.node-select {
  div {
    display: inline-block;
    margin: 4px;
    cursor: pointer;
    padding: 8px;
    border: 1px solid #f8f9f9;
    background-color: #f8f9f9;
    border-radius: 10px;
    width: 130px;
    position: relative;
    span {
      position: absolute;
      left: 56px;
      top: 18px;
    }
    &:hover {
      background-color: #fff;
      box-shadow: 0 0 8px 2px #d6d6d6;
    }
    i {
      font-size: 25px;
      padding: 5px;
      border: 1px solid #dedfdf;
      border-radius: 14px;
    }
  }
}
</style>
